import { useLatest } from 'ahooks';
import { useEffect, useRef } from 'react';
enum LongPressStatue {
  Init,
  INLongPress,
  Trigger,
}
export const useSpaceLongPress = (onLongPress: () => void, onLongPressEnd?: () => void) => {
  const delay = 300;
  const timerRef = useRef<ReturnType<typeof setTimeout>>();
  const isTriggeredRef = useRef<LongPressStatue>(LongPressStatue.Init);
  const onLongPressRef = useLatest(onLongPress);
  const onLongPressEndRef = useLatest(onLongPressEnd);

  useEffect(() => {
    const onStart = (event: KeyboardEvent) => {
      if (event.code == 'Space') {
        if (
          isTriggeredRef.current === LongPressStatue.INLongPress ||
          isTriggeredRef.current === LongPressStatue.Trigger
        ) {
          return;
        }
        isTriggeredRef.current = LongPressStatue.INLongPress;
        timerRef.current = setTimeout(() => {
          onLongPressRef.current();
          isTriggeredRef.current = LongPressStatue.Trigger;
        }, delay);
      }
    };

    const onEnd = (event: KeyboardEvent) => {
      if (event.code == 'Space') {
        if (timerRef.current && isTriggeredRef.current !== LongPressStatue.Trigger) {
          clearTimeout(timerRef.current);
          isTriggeredRef.current = LongPressStatue.Init;
        }
        if (onLongPressEndRef.current && isTriggeredRef.current === LongPressStatue.Trigger) {
          onLongPressEndRef.current();
        }
        isTriggeredRef.current = LongPressStatue.Init;
      }
    };

    document.addEventListener('keydown', onStart);
    document.addEventListener('keyup', onEnd);

    return () => {
      document.removeEventListener('keydown', onStart);
      document.removeEventListener('keyup', onEnd);
    };
  }, []);
};
